import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Addon, AddonCollections } from 'store/addons';
import { StateService } from '@uirouter/core';
import { AddonRouteType, AddonStatus, GtpState } from 'my-account/constants';
import { CmsInternationalTravel, CmsMyAccountModals } from 'store/cms/models';
import { Chat, CimaCore, Cloudinary, Formatter, Util, XmStore, XmStoreUtil } from 'core/services';
import * as MobileDetect from 'mobile-detect';
import { MyAccountModal } from 'my-account/services/modal';
import { XmPayAsYouGoModal } from 'my-account/shared/modals/pay-as-you-go/pay-as-you-go';

@Component({
    selector: 'xm-addon-international-travel',
    templateUrl: './international-travel.html',
    styleUrls: ['./international-travel.scss'],
    standalone: false
})
export class XmInternationalTravel implements OnInit, OnDestroy {
    public pageData: CmsInternationalTravel;
    public gtpData: Addon;
    public gtpContent: GtpContent;
    public gtpCmsData: CmsAddonPlan;
    public gtpImage: MediaImageOptions;
    public inUseIcon: MediaImageOptions;
    public showActiveIcon: boolean = true;
    public gtpFeatures: AddonFeatureDetail[];
    public isBusinessUser: boolean;
    public isMobile: boolean;
    public gtpState: string;
   
    private accountModal: MyAccountModal;
    private payAsYouGoModalData: CmsPayAsYouGoModal;
    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private state: StateService;
    private cimaCore: CimaCore;
    private mobileDetect: MobileDetect = new MobileDetect(navigator.userAgent);

    constructor(accountModal: MyAccountModal, cimaCore: CimaCore, chat: Chat, state: StateService, xmStore: XmStore ) {
        Object.assign(this, { accountModal, cimaCore, chat, state, xmStore });
    }

    public ngOnInit(): void {
        this.isBusinessUser = this.cimaCore.isBusinessUser;
        this.isMobile = Boolean(this.mobileDetect.mobile());

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsInternationalTravel>(CmsInternationalTravel), (result: CmsInternationalTravel) => {
            this.pageData = result;
            this.pageData.gtpContent = this.pageData.gtpContentEnhancement;
            this.gtpImage = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.gtpIcon)
            };
            this.inUseIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.inUseIcon)
            };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AddonCollections>(AddonCollections, { filters: { lineId: this.state.params.line_id } }), (addons: AddonCollections) => {
            this.gtpData = addons.addons.find((addon: Addon) => addon.isGtp);
            if (this.gtpData) {
                this.buildContent();
            } else {
                this.state.go('account.activity.details', { line_id: this.state.params.line_id });
            }
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsMyAccountModals>(CmsMyAccountModals), (cms: CmsMyAccountModals) => {
            this.payAsYouGoModalData = cms.modals.payAsYouGoModal;
        }));
        
    }

    public buildContent(): void {
        switch (this.gtpData.state) {
            case AddonStatus.ACTIVE:
                if (this.gtpData.session) {
                    if (this.gtpData.session.endTime) {
                        this.gtpState = GtpState.ACTIVE_TIMESTAMP;
                    } else {
                        this.gtpState = GtpState.ACTIVE;
                    }
                } else {
                    this.gtpState = GtpState.SELECTED;
                }
                break;
            case AddonStatus.INACTIVE:
                if (this.gtpData.session) {
                    if (this.gtpData.session.endTime) {
                        this.gtpState = GtpState.REMOVED_TIMESTAMP;
                    } else {
                        this.gtpState = GtpState.REMOVED;
                    }
                } else {
                    this.gtpState = GtpState.DEFAULT;
                    this.showActiveIcon = false;
                }
        }

        this.gtpContent = this.pageData.gtpContent.find((content: GtpContent) => content.state === this.gtpState);
        this.gtpFeatures = this.gtpContent.features && this.gtpContent.features.map((feature: CmsAddonFeature) => ({
            header: feature.header,
            icon: {
                mobile: Cloudinary.generateMediaFromCms(feature.icon)
            },
            cbmheader: feature.cbmheader
        }));
        this.gtpContent = this.replaceTimeStamp(this.gtpContent);
    }

    public replaceTimeStamp(content: GtpContent): GtpContent {
        if (this.gtpData.session && this.gtpData.session.endTime) {
            const header: string = content.header.replace('[ENDTIME]', Formatter.formatDateWithTime(this.gtpData.session.endTime));
            const description: string = content.description.replace('[ENDTIME]', Formatter.formatDateWithTime(this.gtpData.session.endTime));

            return { ...content, header, description };
        }

        return content;
    }

    public launchGtpFlow(): void {
        this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.GTP, intent: 'add' });
    }

    public onSecondaryBtnClick(): void {
        this.state.go('account.activity.details.travel-rate', this.state.params);
    }

    public launchPayAsYouGoModal(supportLink: CmsGtpSupportLink): void {
        if (supportLink.isModal) {
            this.accountModal.open(XmPayAsYouGoModal, this.payAsYouGoModalData);
        }
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

}
